import { Checkbox, styled } from '@mui/material';
import theme from 'App.theme';

const StyledCheckbox = styled(Checkbox)`
  &.MuiCheckbox-root {
    padding-top: 0;
    padding-bottom: 0;
  }

  &:not(.Mui-disabled) > svg {
    fill: ${(props) =>
      props.color === 'error'
        ? theme.palette.error.main
        : theme.palette.primary.light};
  }
`;

export default StyledCheckbox;
